import { render, staticRenderFns } from "./ModalDesativarMonitoramento.vue?vue&type=template&id=5ca4def6&scoped=true&lang=pug"
import script from "./ModalDesativarMonitoramento.vue?vue&type=script&lang=js"
export * from "./ModalDesativarMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./ModalDesativarMonitoramento.vue?vue&type=style&index=0&id=5ca4def6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca4def6",
  null
  
)

export default component.exports